import React from "react";
import "./ServicesList.css";
import ServiceCard from "../ServiceCard/ServiceCard";

const servicesData = [
  {
    icon: "💎",
    title: "Jewellery ERP Development",
    desc: "Custom ERP Solutions Tailored to Your Workflow",
    features: [
      "Product & category management",
      "Live gold, diamond & metal rate integration",
      "Stock & inventory tracking",
      "Order, invoice & billing management",
      "Barcode & tagging systems",
      "Role-based access for staff",
      "Reports & analytics dashboard",
    ],
    idealFor: "Retailers, Wholesalers, Manufacturers, Chain Stores",
  },
  {
    icon: "🌐",
    title: "Custom Website Development",
    desc: "High-Performance Websites That Represent Your Brand",
    features: [
      "Corporate & brand websites",
      "Jewellery product catalog websites",
      "E-commerce websites",
      "Admin panels for content & product control",
      "Fast loading & mobile-optimized designs",
    ],
  },
  {
    icon: "📱",
    title: "Mobile App Development",
    desc: "Android & iOS Apps for Jewellery Businesses",
    features: [
      "Customer shopping & catalogue apps",
      "Sales & order management apps",
      "Staff & internal operations apps",
      "Retailer-wholesaler order apps",
      "Real-time updates",
      "Secure login (OTP / Email / Mobile)",
      "Push notifications",
      "Smooth and intuitive UI",
    ],
  },
  {
    icon: "🧩",
    title: "Custom Software Development",
    desc: "Solutions Built Exactly as Your Business Needs",
    features: [
      "Custom order management systems",
      "Client-specific pricing modules",
      "Multi-branch business systems",
      "Manufacturer-retailer portals",
    ],
  },
  {
    icon: "📊",
    title: "Admin Dashboards & Reporting",
    desc: "Complete Business Visibility at One Place",
    features: [
      "Sales & order reports",
      "Stock & inventory analytics",
      "User activity tracking",
      "Custom exportable reports",
    ],
  },
];

const ServicesList = () => {
  return (
    <section className="services-list">
      {servicesData.map((service, idx) => (
        <ServiceCard key={idx} {...service} />
      ))}
    </section>
  );
};

export default ServicesList;
